import posthog from "posthog-js";
import { createAnalyticsClient, type AnalyticsClient } from "./posthog-client";

export type BrowserAnalyticsOptions = {
  apiKey?: string;
  host?: string;
  enabled?: boolean;
  autocapture?: boolean;
  capturePageview?: boolean;
  globalProperties?: Record<string, unknown>;
  onError?: (error: unknown) => void;
};

export const createBrowserAnalyticsClient = (
  options: BrowserAnalyticsOptions = {},
): AnalyticsClient => {
  const {
    apiKey,
    host,
    enabled = Boolean(apiKey),
    autocapture = false,
    capturePageview = false,
    globalProperties = {},
    onError,
  } = options;

  if (!apiKey || !enabled) {
    return createAnalyticsClient({ capture: async () => {}, enabled: false });
  }

  posthog.init(apiKey, {
    api_host: host,
    autocapture,
    capture_pageview: capturePageview,
    capture_pageleave: false,
    disable_session_recording: true,
    persistence: "localStorage",
  });

  const browserClient = posthog as typeof posthog & {
    shutdown?: () => void;
    flush?: () => void;
  };

  return createAnalyticsClient(
    {
      capture: ({ event, properties, distinctId }) => {
        browserClient.capture(event, properties);
        if (distinctId) {
          browserClient.identify(distinctId, properties);
        }
      },
      identify: (distinctId, properties) => {
        browserClient.identify(distinctId, properties);
      },
      registerProperties: (properties) => {
        browserClient.register(properties);
      },
      enabled,
      onError,
    },
    globalProperties,
  );
};
